// extracted by mini-css-extract-plugin
module.exports = {"filter":"Subscriptions_filter__3nreK","table_link":"Subscriptions_table_link__1dqUE"};